import ProfessionListCard from './ProfessionListCard.vue';

export default ProfessionListCard;



// WEBPACK FOOTER //
// ./src/components/parts/professions/card/index.ts